<template>
  <IndexPanel
    v-if="listItems?.length > 0"
    :initialData="listItems"
    :modelValue="searchResults"
    operationType="shafts_v2_shafts"
  />

  <OperationList
    v-slot="slotProps"
    :listItems="searchResults"
    operationType="shafts_v2_shafts"
  >
    <OperationItem
      v-for="item in slotProps.item.shafts_v2_shafts"
      :id="item.id"
      :key="item.id"
      barChart
      endpointIdentifier="shafts_v2/shafts"
      :itemRoutes="{
        view: { name: 'shaftV2Dashboard', params: { shaftId: item.id } },
        edit: { name: 'shaftV2ConfigurationShafts', params: { organisationId: props.organisationId, shaftId: item.id } },
      }"
      :organisationId="organisationId"
      @reload="reload"
    />
  </OperationList>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import useAjax from '@/functions/use_ajax';

// Components
import OperationList from '@/components/operations/operations_list.vue';
import OperationItem from '@/components/operations/operation_item.vue';
import IndexPanel from '@/components/form/index_panel.vue';

const emit = defineEmits(['update']);

const props = defineProps({
  organisationId: { type: String, default: null },
});

const ajax = useAjax();
const listItems = ref([]);
const loading = ref(true);
const searchResults = ref([]);

const itemCount = computed(() => {
  return searchResults.value?.reduce(function (acc, obj) {
    return acc + (obj.shafts_v2_shafts?.length || 0);
  }, 0);
});

onMounted(load);
watch(props, load);
watch(itemCount, emitCount);

function emitCount() {
  emit('update', {
    count: itemCount.value || 0,
    label: 'shafts',
    loading: loading.value,
  });
}

async function load() {
  await loadShafts();
  loading.value = false;

  emitCount();
}

async function loadShafts() {
  let { ok, data } = await ajax(`/organisations/${props.organisationId}/shafts_v2/shafts`);

  if (ok) {
    listItems.value = JSON.parse(JSON.stringify(data.divisions));
    searchResults.value = data.divisions;
  }
}

function reload(data) {
  if (data?.type === 'delete') {
    listItems.value.forEach((division, index) => {
      division.shafts_v2_shafts = division?.shafts_v2_shafts.filter(operation => operation.id !== data?.id);
      searchResults.value[index].shafts_v2_shafts = searchResults.value[index]?.shafts_v2_shafts.filter(operation => operation.id !== data?.id);
    });
  }
}
</script>
